type Transaction = {
  title: string;
  time: string;
  points: string;
};

type RewardsPreviewCardProps = {
  transactions: Transaction[];
};

export const RewardsPreviewCard = ({ transactions }: RewardsPreviewCardProps) => {
  return (
    <div className="relative overflow-hidden rounded-[28px] lg:rounded-[36px] bg-[linear-gradient(90deg,#990000_0%,#CD0000_40%,#990000_100%)] px-[20px] sm:px-8 lg:px-16 pt-6 lg:pt-16 pb-6 lg:pb-14">
      <img
        src="/images/Webp/layer-1.webp"
        alt=""
        aria-hidden="true"
        className="absolute inset-0 w-full h-full object-cover opacity-90 pointer-events-none"
      />

      <div className="relative z-10 flex items-center justify-between gap-[16px]">
        <div className="flex items-center gap-[16px] lg:gap-8">
          <div className="flex-shrink-0 flex items-center justify-center w-[64px] h-[64px] lg:w-[94px] lg:h-[94px] rounded-[16px] lg:rounded-[22px] bg-white border-[3px] border-[#FF3B3B]">
            <img src="/images/Webp/business/TrophyIcon.webp" alt="" aria-hidden="true" className="w-[44px] h-[44px] lg:w-[66px] lg:h-[66px] object-contain" />
          </div>
          <div>
            <div className="text-white text-[24px] lg:text-[36px] font-medium leading-none">2,450 pts</div>
            <div className="mt-[8px] lg:mt-3 text-white text-[14px] lg:text-[22px]">Total earned this month</div>
          </div>
        </div>

        <div className="relative flex-shrink-0 w-[70px] h-[70px] lg:w-[114px] lg:h-[114px]">
          <img src="/images/star-2.svg" alt="" aria-hidden="true" className="w-full h-full" />
          <div className="absolute inset-0 flex flex-col items-center justify-center text-[#111] leading-tight">
            <span className="text-[11px] lg:text-[17px]">Earn</span>
            <span className="text-[14px] lg:text-[22px] font-medium">2X</span>
            <span className="text-[11px] lg:text-[17px]">Points</span>
          </div>
        </div>
      </div>

      <div className="relative z-10 mt-8 lg:mt-12 space-y-3 lg:space-y-5">
        {transactions.map((transaction) => (
          <div
            key={transaction.title}
            className="flex items-center justify-between gap-[16px] rounded-[18px] lg:rounded-[24px] border-[2px] border-white/90 bg-white/25 backdrop-blur-[6px] px-[20px] lg:px-12 py-[16px] lg:py-5"
          >
            <div>
              <div className="text-white text-[16px] lg:text-[28px] leading-[1.2]">{transaction.title}</div>
              <div className="mt-[4px] lg:mt-2 text-white/95 text-[13px] lg:text-[22px]">{transaction.time}</div>
            </div>
            <div className="text-white text-[30px] lg:text-[52px] font-medium leading-none whitespace-nowrap">
              {transaction.points}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
